import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AppRouter } from './app/router';
import { ApiAuthGate } from './components/ApiAuthGate';
import { RequireAuth } from './components/RequireAuth';
import { captureTokenFromUrl } from './shared/auth/userToken';
import './i18n/config';
import './index.css';

// D11: если вернулись из Google OIDC — забрать app-JWT из #access_token и почистить URL (до рендера).
captureTokenFromUrl();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // при недоступности API не накапливать повторные запросы
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RequireAuth>
          <ApiAuthGate>
            <AppRouter />
          </ApiAuthGate>
        </RequireAuth>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
